/* cs-p02-layout.js
 * P-02 系列頁版面「乙」的「隱藏篩選／顯示篩選」鈕。第三十一輪收尾店主選乙（10-11）：正式 collection.p02 預設就是乙，collection.p02-b 與它相同。只在 cs_variant 是 b 時由 sections/cs-p02-collection.liquid 載入。
 * 做的事只有一件：切換 root（[data-cs-p02]）上的 class cs-p02--side-off，並同步鈕的 aria-expanded；狀態記在 localStorage 鍵 cs-p02:side-off（'1'＝收起）。
 * 文字（隱藏／顯示）、側欄 display:none、版面一欄、3／4 欄都由 assets/cs-p02-collection.css 依這個 class 決定，這裡不量尺寸、不寫任何 CSS 變數。
 * 這支檔案是 defer 載入（theme check 的 ParserBlockingScript 不准同步載入），所以讀到「收起」要等 DOM 解析完才加 class；收起過的客人重新載入頁面時，有機會先看到側欄閃一下再收起。
 * localStorage 每次讀寫都包 try/catch；讀不到（私密視窗、被擋）就當打開，寫不進去也不影響這一次的切換。
 * 鈕在 [data-cs-swap] 之外，換格不會把它換掉；root 也不會被換，所以 class 不會因換格消失。cs-p02-collection.js 完全不知道這支檔案。
 * 桌面（>=990）以外鈕是 display:none、class 的 css 全部在 min-width:990px 內，手機不受影響。
 */
(function () {
  'use strict';
  var KEY = 'cs-p02:side-off';
  var CLS = 'cs-p02--side-off';
  var cur = document.currentScript;
  var root = (cur && cur.closest) ? cur.closest('[data-cs-p02]') : null;
  if (!root) { root = document.querySelector('[data-cs-p02].cs-p02--b'); }
  if (!root || root._csP02Layout) { return; }
  var btn = root.querySelector('[data-cs-p02-side-toggle]');
  if (!btn) { return; }
  root._csP02Layout = true;

  function read() {
    try { return window.localStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function write(off) {
    try { window.localStorage.setItem(KEY, off ? '1' : '0'); } catch (e) { /* 寫不進去：這次切換照樣生效 */ }
  }
  function paint(off) {
    root.classList.toggle(CLS, off);
    btn.setAttribute('aria-expanded', off ? 'false' : 'true');
  }

  paint(read());
  btn.addEventListener('click', function () {
    var off = !root.classList.contains(CLS);
    paint(off);
    write(off);
  });
})();
